export interface GetProductRequest {
  shopifyProductIds?: (number | string)[]
  contentfulProductIds?: string[]
  internalProductIds?: (number | string)[]
  options?: ProductServiceOptions[]
  extraParams?: object
  useLite?: boolean
  zipCode?: string
  isChildProduct?: boolean // Not being used in API
  overrideClientExclusivity?: boolean // Not being used in API
}
export interface GetSearchProductRequest {
  productColors: string
  zipCode: string | undefined
}

export interface GetReportingServiceProductRequest {
  options?: ProductServiceOptions[]
  extraParams?: object
  isRuntime?: boolean
}

export enum ProductServiceOptions {
  ENRICH_OFFER_MESSAGE = 'ENRICH_OFFER_MESSAGE',
  ENRICH_DESCRIPTION = 'ENRICH_DESCRIPTION',
  ENRICH_DETAILS = 'ENRICH_DETAILS',
  ENRICH_CARE_AND_MAINTENANCE = 'ENRICH_CARE_AND_MAINTENANCE',
  ENRICH_COMPARISON_BRANDS = 'ENRICH_COMPARISON_BRANDS',
  ENRICH_PRODUCT_REVIEWS = 'ENRICH_PRODUCT_REVIEWS',
  ENRICH_TRANSPARENT_PRICING = 'ENRICH_TRANSPARENT_PRICING',
  ENRICH_SIZE_CHART = 'ENRICH_SIZE_CHART',
  ENRICH_ONLY_TAGS = 'ENRICH_ONLY_TAGS',
  ENRICH_SIZE_AND_FIT = 'ENRICH_SIZE_AND_FIT',
  ENRICH_REFRESH_LITE = 'ENRICH_REFRESH_LITE',
}
